import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useCompany } from "../CompanyProvider/CompanyProvider";
import { tokenReplace } from "../../utils/tokenReplacement";
import { Tokens } from "../../sharedTypes/Tokens";
export const SkippedMealTextBox = ({ selectedDay, programMealName, dateFormat, text, buttonText, onClick, }) => {
    const { tokenMap } = useCompany();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"), { noSsr: true });
    return (_jsx(Box, Object.assign({ id: "skipped-meal-textbox", sx: (theme) => ({
            border: `1px solid ${theme.palette.primary.main}`,
            padding: theme.spacing(1),
            backgroundColor: theme.palette.background.paper,
            borderRadius: theme.spacing(1),
            boxShadow: theme.shadows[3],
        }), display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }, { children: _jsxs(Stack, Object.assign({ direction: "row", spacing: 1, justifyContent: "center", alignItems: "center", flexWrap: "wrap" }, { children: [_jsx(Typography, Object.assign({ textAlign: "center" }, { children: tokenReplace(text
                        .replace(Tokens.ProgramMealName, programMealName)
                        .replace(Tokens.Day, selectedDay.format(dateFormat)), false, tokenMap) })), _jsx(Button, Object.assign({ variant: "text", sx: (theme) => ({
                        textTransform: "none",
                        textDecoration: "underline",
                        color: theme.palette.getContrastText(theme.palette.background.paper),
                    }), fullWidth: isMobile, onClick: onClick }, { children: tokenReplace(buttonText, false, tokenMap) }))] })) })));
};
